import React from 'react';
import { X } from 'lucide-react';

const AddToMeetingModal = ({
  isOpen,
  onClose,
  meetingConversation,
  existingMeetings,
  selectedMeetingId,
  setSelectedMeetingId,
  onAddToMeeting
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-gray-900 border border-gray-400/20 rounded-2xl w-[500px] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="p-6 border-b border-gray-400/20">
          <h2 className="text-xl font-bold text-white">Add to Existing Meeting</h2>
          <p className="text-gray-400 text-sm mt-1">Link {meetingConversation?.name} to a meeting card</p>
        </div>
        
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">Select Meeting</label>
            <select
              value={selectedMeetingId}
              onChange={(e) => setSelectedMeetingId(e.target.value)}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-400/20 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-400"
            >
              <option value="">-- Select a meeting --</option>
              {existingMeetings.map((meeting, idx) => (
                <option key={idx} value={meeting.id || idx}>
                  {meeting.title || meeting.name || `Meeting ${idx + 1}`} - {meeting.status || 'N/A'}
                </option>
              ))}
            </select>
          </div>
          
          {existingMeetings.length === 0 && (
            <p className="text-gray-400 text-sm text-center py-4">No meetings found. Create a new meeting instead.</p>
          )}
        </div>
        
        <div className="p-6 border-t border-gray-400/20 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onAddToMeeting}
            disabled={!selectedMeetingId}
            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white rounded-lg transition-colors"
          >
            Add to Meeting
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddToMeetingModal;
